import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';

export default function overwriteDocumentsReducer(state = initialState.overwriteDocuments, action) {
	switch (action.type) {
		case types.GET_OVERWRITE_DOCUMENTS: {
			let _state = {...state, documents: action.response.data, forms: state.forms};
			return _state;
		}
		case types.GET_OVERWRITE_FORMS: {
			let _state = {...state, forms: action.response, documents: state.documents};
			return _state;
		}
		case types.POST_OVERWRITE_DOCUMENT:
			return action.response;
		case types.CREATE_DOCUMENT_SNAPSHOT:
			return action.response;
		case types.RESET_OVERWRITE:
			return initialState.overwriteDocuments;
		default:
			return state;
	}
}
